import BaseCdeIcon, { CdeIconProps } from './BaseCdeIcon'
import { ReactComponent as Read } from '../../../assets/permission-icons/read.svg'

const CdeIconRead: React.FC<CdeIconProps> = ({ status, onClick }) => {
  return <BaseCdeIcon onClick={onClick} status={status} icon={<Read />} />
}

export default CdeIconRead
